<template>
  <div :class="dialog ? '' : 'card'">
    <component :is="selectedComponent"
      :visible.sync="meetingDialog1"
      :key="meetingDialogKey"
      :style="meetingDialog? { width: '760px', height: showMore ? 'auto' : '350px' }:''"
      header="Result"
      :modal="meetingDialog?true:''"
      class="p-fluid"
      id="meetingDialog"
      @keyup="keyMonitor"
    >
      <div class="p-formgrid p-grid">
        <div class="p-field col">
          <label for="contact">Activity Result</label>
          <Dropdown
            v-model="result"
            :options="activityResults"
            optionLabel="resultDesc"
            dataKey="id"
            placeholder="Select Activity Result"
            :showClear="true"
            :class="{ 'p-invalid': submitted && !thisActivity.activityResult }"
          />
          <small class="p-invalid" v-if="submitted && !thisActivity.activityResult"
            >Activity Result is required.</small
          >
        </div>
      </div>
      <div class="p-formgrid p-grid">
        <div class="p-field col">
          <label for="notes">Result notes</label>
          <Textarea 
            v-model.trim="thisActivity.notes" 
            :autoResize="true" 
            :rows="getRowSize()"
            required="false"
            autofocus
            :class="{ 'p-invalid': submitted && !thisActivity.notes }"
          />
          <small class="p-invalid" v-if="submitted && !thisActivity.notes"
            >Notes are required.</small
          >
        </div>
      </div>
      <!-- G4 + G6: result "Create follow-up" - a task (date, optional time) or an event (start and end) -->
      <FollowUpFields v-if="showMore && followUp" :form="followUp" :types="activityTypes" :users="users" :problem="followUpProblemText" />

      <template #footer>
        <div class="p-grid" style="padding-top: 10px;">
          <div class="p-lg-4 p-md-3 p-sm-3">
          </div>
          <div class="p-lg-4 p-md-3 p-sm-3">
          </div>
          <div class="p-lg-2 p-md-3 p-sm-3">
            <Button
              label="Cancel"
              icon="pi pi-times"
              class="p-button-danger"
              @click="$emit('close')"
              style="width: 100px;"
            />
          </div>
          <div class="p-lg-2 p-md-3 p-sm-3">
            <ProgressSpinner 
              v-if="sendingRequest"
              style="width:25px; height:25px; width: 100px;" 
              strokeWidth="5" 
              fill="#EEEEEE" 
              animationDuration=".5s"
            />
            <Button
              v-else
              label="Save"
              icon="pi pi-check"
              class="p-button-success"
              @click="save"
              style="width: 100px;"
            />
          </div>
        </div>
      </template>
    </component>
    <div class="flex justify_space_between my-1">
      <div>
      </div>
      <div v-if="!dialog"
        style="width: 250px; display: flex; justify-content: flex-end;">
        <ProgressSpinner
          v-if="sendingRequest"
          style="width:25px; height:25px; width: 100px;" 
          strokeWidth="5" 
          fill="#EEEEEE" 
          animationDuration=".5s"
        />
        <Button
          v-else
          label="Save"
          icon="pi pi-check"
          style="width: 100px;"
          @click="save"
        />
      </div>
    </div>
  </div>
</template>

<script>
import ActivityService from "@/service/ActivityService";
import UserService from "@/service/UserService";
import FollowUpFields from "./FollowUpFields";
import { newFollowUp, followUpProblem, followUpBody, carriedNotes } from "@/mbp/activityFollowUp";

export default {
  components: { FollowUpFields },
  created() {
    new UserService().getAllActiveUsers().then((data) => (this.users = data || [])).catch(() => {});
    this.activityService
      .getAllActiveActivityResults()
      .then((data) => (this.activityResults = data))
      .catch((e) => {
        
          
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting activity results",
        //   life: 5000,
        // })
        this.$store.dispatch('addErrorMessage', {
          severity: 'error',
          content: 'Some data was not loaded from "activeActivityResults"'
        })
      });
    this.activityService
      .getAllActivityTypes()
      .then((data) => (this.activityTypes = data))
      .catch((e) => {
        
          
        // this.$toast.add({
        //   severity: "error",
        //   summary: "Error",
        //   detail: "Error while getting activity types",
        //   life: 5000,
        // })
        this.$store.dispatch('addErrorMessage', {
          severity: 'error',
          content: 'Some data was not loaded from "activityTypes"'
        })
      });
  },
  props: {
    meetingDialog: {
      type: Boolean,
      required: true
    },
    dialog: {
      type: Boolean,
      default: true
    },
    reload: {
      type: Number,
      required: false
    },
    activity: {
      type: Object,
      required: true
    },
    sendingRequest: {
      type: Boolean,
      required: true
    }
  },
  data: () => ({
    activityService: new ActivityService(),
    comment: '',
    submitted: false,
    meetingDialogKey: 0,
    activityResults: [],
    activityTypes: [],
    thisActivity: {},
    showMore: false,
    result: {},
    startDate: null,
    startTime: null,
    showStartDateError: false,
    users: [],
    followUp: null,
    followUpProblemText: null,
    followUpDefaultNotes: '',
  }),
  computed: {
    meetingDialog1: {
      set(val) {
        if (!val) {
          this.$emit('close')
        }
      },
      get() {
        return this.meetingDialog
      }
    },
    selectedComponent() {
        if(this.dialog)
        {
            return 'Dialog'
        }
        else {
            return 'div'
        }
    }
  },
  watch: {
    result(val) {
      this.thisActivity.activityResult = val
      if (val && val.createActivity) {
        this.showMore = true
        this.followUp = newFollowUp(this.activity, this.$store.getters['auth/getMyProfile'])
        this.followUpDefaultNotes = this.followUp.notes
        this.followUpProblemText = null
      } else {
        this.showMore = false
        this.followUp = null
      }
    },
    activity(val) {
      this.thisActivity = {...val}
    },
    reload() {
      this.refreshComponent()
    }
  },
  methods: {
    keyMonitor(event) {
      // 
      if (event.key === 'Tab') {
        let a = document.activeElement
        if (a) {

          let b = document.getElementsByClassName('p-datepicker p-component')
          b.forEach(c => {
            let found = false // when moving from date to date (date === time)
            let found1 = true // when going from date to dropdown (specially in primevue)

            c.parentElement.children.forEach(d => {
              // 

              if (d.id === a.id) {
                found = true
              }
              if (d.id && a.parentElement.parentElement.id && d.id !== a.parentElement.parentElement.id) {
                found1 = false
              }
            })
            // 
            if (!found || !found1) {
              c.style.visibility = "hidden";
            }
          })
        }
        
      }

    },
    refreshComponent() {
      this.thisActivity = {}
      this.showMore = false
      this.result = {}
      this.startDate = null
      this.startTime = null
      this.showStartDateError = false
      this.followUp = null
      this.followUpProblemText = null
      this.submitted = false
      this.sendingRequest = false
      this.meetingDialogKey++
    },
    getRowSize() {
      if (this.notes) {
        let len = this.notes.split('\n')
        return (Math.floor(this.notes.length / 100) + len.length).toString()
      } else {
        return '2'
      }
    },
    save() {
      this.submitted = true
      
      if (
        this.thisActivity.activityResult &&
        this.thisActivity.activityResult.id &&
        this.thisActivity.activityResult.createActivity &&
        this.followUp
      ) {
        this.followUpProblemText = followUpProblem(this.followUp)
        if (!this.followUpProblemText && this.thisActivity.notes) {
          // the result notes are typed after the follow-up opens: carry them too, unless the notes were edited
          if (this.followUp.notes === this.followUpDefaultNotes) {
            this.followUp.notes = carriedNotes({ notes: this.activity.notes, resultNotes: this.thisActivity.notes })
          }
          this.$emit('save', { ...this.thisActivity, followUp: followUpBody(this.followUp) })
        }
      } else if (
        this.thisActivity.activityResult &&
        this.thisActivity.activityResult.id &&
        this.thisActivity.notes
      ) {
        this.$emit('save', this.thisActivity)
      }
    }
  }
}
</script>

<style>

</style>